import { useState } from "react";
import { Link } from "react-router-dom";
import { Download, X, BadgeAlert } from "lucide-react";
import { downloadAPK } from "../Helpers/DownloadAPK";
import { GiNetworkBars } from "react-icons/gi";

const Section4 = ({ GameData, title, showPana }) => {
  const [ModalData, setModalData] = useState([]);
  const [show, setShow] = useState(false);
  const [RowData, setRowData] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setShow(true);
    setRowData(data);
  };

  const download = async (e) => {
    e.preventDefault();
    await downloadAPK();
  };

  const showData = (data) => {
    const weekday = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    if (data?.length > 0) {
      for (const item of data) {
        if (
          weekday
            .map((day) => day.toLowerCase())
            .includes(item.gameDay?.toLowerCase())
        ) {
          return item;
        }
      }
    }
  };

  const getStatusConfig = (message) => {
    if (message === "Close for today") {
      return { text: "Closed", color: "tw-bg-red-100 tw-text-red-600" };
    } else if (
      message === "Betting is running for close" ||
      message === "Betting is running for open"
    ) {
      return { text: "Open", color: "tw-bg-green-100 tw-text-green-600" };
    } else {
      return { text: "Upcoming", color: "tw-bg-yellow-100 tw-text-yellow-700" };
    }
  };

  return (
    <>
      <div id="markets" className="tw-py-12 tw-px-4 md:tw-px-8 lg:tw-px-12">
        <div className="tw-max-w-7xl tw-mx-auto">
          {/* Header */}
          <div className="tw-text-center tw-mb-8">
            <h2 className="tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-bold tw-mb-4">
              {title || "Today's Market Results"}
            </h2>
            <p className="tw-max-w-3xl tw-mx-auto tw-text-gray-600 tw-text-sm md:tw-text-base">
              Real-Time Results From All Major Markets. Click On Any Market To
              View Charts Or Download Our App To Play.
            </p>
          </div>

          {/* Market Cards */}
          <div className="tw-space-y-4">
            {GameData?.filter((item) => item.activeStatus === true)?.map((data, index) => {
              const gameData = showData(data?.gameDetails);
              const statusConfig = getStatusConfig(gameData?.message);

              return (
                <div
                  key={index}
                  className="tw-bg-white tw-rounded-2xl tw-p-4 md:tw-p-6
                   tw-shadow-sm hover:tw-shadow-md tw-transition-shadow"
                >
                  <div
                    className="tw-flex tw-flex-col lg:tw-flex-row
                     tw-gap-4 lg:tw-items-center lg:tw-justify-between"
                  >
                    {/* LEFT */}
                    <div className="tw-flex-1">
                      <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-mb-2">
                        <h3 className="tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-bold tw-text-gray-900">
                          {data.providerName?.toUpperCase()}
                        </h3>

                        <span
                          className={`tw-px-3 tw-py-1 tw-rounded-full
                tw-text-xs tw-font-semibold ${statusConfig.color}`}
                        >
                          {statusConfig.text}
                        </span>
                      </div>

                      <div
                        className="tw-flex tw-flex-wrap tw-items-center tw-gap-2
                            tw-text-xs sm:tw-text-sm tw-text-gray-600"
                      >
                        <span>Open: {gameData?.OBT || "10:00 AM"}</span>
                        <span className="tw-hidden sm:tw-inline">•</span>
                        <span>Close: {gameData?.CBT || "11:00 AM"}</span>
                      </div>
                    </div>

                    {/* RESULT */}
                    <div className="tw-text-center tw-py-2 lg:tw-py-0">
                      {/* <p className="tw-text-[10px] sm:tw-text-xs tw-text-gray-500 tw-uppercase tw-mb-1">
                        Result
                      </p> */}
                      <p
                        className="tw-text-xl sm:tw-text-2xl md:tw-text-3xl
                          tw-font-bold tw-text-[#1e6ebe]"
                      >
                        {data.providerResult || "878-98-890"}
                      </p>
                    </div>

                    {/* ACTIONS */}
                    <div
                      className="tw-flex tw-flex-col sm:tw-flex-row
                       tw-gap-2 sm:tw-gap-3
                       tw-w-full lg:tw-w-auto"
                    >
                      <Link
                        to={`/jodi-chart/${data?.providerName
                          ?.toLowerCase()
                          .replace(/\s+/g, "")}/jodi-chart`}
                        state={{ title: data?.providerName, id: data._id }}
                        className="tw-flex tw-items-center tw-justify-center tw-gap-2
                         tw-w-full sm:tw-w-auto
                         tw-px-4 tw-py-2
                         tw-bg-teal-200 tw-text-[#1e6ebe]
                         tw-rounded-lg tw-text-sm tw-font-medium
                         tw-no-underline"
                      >
                        <GiNetworkBars className="tw-w-4 tw-h-4" />
                        Jodi Chart
                      </Link>

                      {showPana && (
                        <Link
                          to={`/pana-chart/${data?.providerName
                            ?.toLowerCase()
                            .replace(/\s+/g, "")}/pana-chart`}
                          state={{ title: data?.providerName, id: data._id }}
                          className="tw-flex tw-items-center tw-justify-center tw-gap-2
                           tw-w-full sm:tw-w-auto
                           tw-px-4 tw-py-2
                           tw-bg-gray-100 tw-text-gray-700
                           tw-rounded-lg tw-text-sm tw-font-medium
                           tw-no-underline"
                        >
                          <GiNetworkBars className="tw-w-4 tw-h-4" />
                          Pana Chart
                        </Link>
                      )}

                      <button
                        onClick={download}
                        className="tw-flex tw-items-center tw-justify-center tw-gap-2
                         tw-w-full sm:tw-w-auto
                         tw-px-5 tw-py-2
                         tw-bg-[#01A1A4]
                         tw-text-white tw-rounded-lg
                         tw-text-sm tw-font-medium"
                      >
                      
                        <Download className="tw-w-4 tw-h-4" />
                        Play
                      </button>
                      <button
                        onClick={() => {
                          handleShow(data);
                          setModalData(gameData);
                        }}
                        className="tw-flex tw-items-center tw-justify-center tw-gap-2
                         tw-w-full sm:tw-w-auto
                         tw-px-5 tw-py-2
                         tw-bg-[#1e6ebe]
                         tw-text-white tw-rounded-lg
                         tw-text-sm tw-font-medium"
                      >
                        <BadgeAlert className="tw-w-4 tw-h-4" />
                        Info
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* View All */}
          <div className="tw-text-center tw-mt-12">
            <button className="tw-font-semibold tw-text-[#1e6ebe] tw-text-md">
              View All Markets ▶
            </button>
          </div>
        </div>
      </div>

      {/* MODAL */}
      {show && (
        <div
          className="tw-fixed tw-inset-0 tw-bg-black/50
                        tw-flex tw-items-center tw-justify-center
                        tw-z-50 tw-p-4"
        >
          <div className="tw-bg-white tw-rounded-2xl tw-max-w-md tw-w-full">
            <div
              className="tw-bg-[#1e6ebe]
                            tw-p-6 tw-text-white tw-relative"
            >
              <button
                onClick={handleClose}
                className="tw-absolute tw-top-4 tw-right-4"
              >
                <X />
              </button>

              <h3 className="tw-text-2xl tw-font-bold">
                {RowData?.providerName}
              </h3>
            </div>

            <div className="tw-p-6">
              <div className="tw-space-y-3">
                <Info label="Open Bid Time" value={ModalData?.OBT} />
                <Info label="Close Bid Time" value={ModalData?.CBT} />
                <Info label="Open Result Time" value={ModalData?.OBRT} />
                <Info label="Close Result Time" value={ModalData?.CBRT} />
              </div>

              <button
                onClick={handleClose}
                className="tw-w-full tw-mt-6 tw-bg-[#1e6ebe]
                           tw-text-white tw-py-3 tw-rounded-lg
                           tw-font-semibold"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const Info = ({ label, value }) => (
  <div className="tw-flex tw-justify-between tw-border-b tw-py-2">
    <span className="tw-text-sm tw-text-gray-600">{label}</span>
    <span className="tw-font-semibold">{value}</span>
  </div>
);

export default Section4;
